<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { xxzzs_query } from '../../../../../api/xxzzs.js';
import { kydkpz_queryCompanyList } from '../../../../../api/kydkpz.js';
import config from '../../../../../../configHttp.js';
import { MainFunction } from '@/components/util/Function/MainFunction';
export default {
	data: function() {
		return {
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			outlist: [],
			options: [],
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [],
			shaidiag: false,
			searchdiag: false,
			// 日期控件初始化时间
			suosqcompanyNo: {
				suosq: MainFunction.$getdefultMonth(),
				companyNo: ''
			},

			// 导出传参类型
			outputData: getdata().outputData,
			// 全部导出
			exportType: '',
			tablekey: 0
		};
	},
	methods: {
		currStationChange(v) {
			this.suosqcompanyNo.companyNo = v;
			this.fetchResultShow();
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.fetchResultShow();
		},
		forRefresh() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.fetchResultShow();
		},

		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
		suosqchange() {
			this.fetchResultShow();
		},
		// 查询进行发票合计结果(分页)
		fetchResultShow() {
			// let params = JSON.parse(JSON.stringify(this.searchdata))
			let params = {}
			params.suosq = this.suosqcompanyNo.suosq;
			params.companyNo = this.suosqcompanyNo.companyNo;
			xxzzs_query(params).then(res => {
				if (res.data.code != 1) {
					this.$message.error(res.data.msg);
				} else {
					this.pagination.total = 1;
					this.tableData = res.data.data;
				}
			});
		},
		chaxungongshihesju() {
			kydkpz_queryCompanyList().then(res => {
				if (res.data.msg == '操作成功') {
					this.options = res.data.data.map(v => {
						return {
							value: v.companyNo,
							label: v.nsrmc
						};
					});
					this.suosqcompanyNo.companyNo = this.options[0].value;
					this.fetchResultShow();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},

		// 导出进项发票合计结果
		outPutIInvResult() {
			let selectVal = this.$refs.tablebox.getSelectionval();
			let data = { suosq: this.suosqcompanyNo.suosq, companyNo: this.suosqcompanyNo.companyNo };
			if (selectVal.length > 0) {
				data.types = selectVal.map(item => item.xiangmcode).join(',');
			}
			let params = {
				downUrl: config.baseURL + 'oinv/list/export',
				typeObj: {
					toForm: false,
					fileName: '销项增值税结果展示' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
					fileType: 'xlsx',
					failUrl:this.$winURl
				},
				params: data
			};
			this.$downloadcommon(params);
		}
	},
	components: {},
	created() {
		this.chaxungongshihesju();
	},
	mounted() {},
	computed: {
		timeDefault() {
			let date = new Date();
			let newDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '期';
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
